<template>
  <div style="display: flex; align-items: center">
    <!-- 示例数据icon -->
    <svg
      class="icon-hover"
      v-if="name === 'example-data'"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.375 5.24989L9 1.5L2.625 5.24989V12.7499L9 16.5L15.375 12.7499V5.24989Z"
        stroke="currentColor"
        stroke-width="1.35"
        stroke-linejoin="round"
      />
      <path
        d="M9 8.25V11.25"
        stroke="currentColor"
        stroke-width="1.35"
        stroke-linejoin="round"
      />
      <path
        d="M12 6.75V11.25"
        stroke="currentColor"
        stroke-width="1.35"
        stroke-linejoin="round"
      />
      <path
        d="M6 9.75V11.25"
        stroke="currentColor"
        stroke-width="1.35"
        stroke-linejoin="round"
      />
    </svg>
    <!-- 画布类型解释 -->
    <svg
      v-if="name === 'canvas-type'"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6 0C4.34331 0 2.84256 0.672172 1.75736 1.75735C0.672178 2.84256 0 4.34331 0 6C0 7.65669 0.672175 9.15744 1.75736 10.2426C2.84256 11.3278 4.34331 12 6 12C7.65669 12 9.15744 11.3278 10.2426 10.2426C11.3278 9.15744 12 7.65669 12 6C12 4.34331 11.3278 2.84256 10.2426 1.75736C9.15744 0.672172 7.65669 0 6 0ZM6 2.35227C4.79502 2.35227 3.81818 3.32911 3.81818 4.53409H4.90909C4.90909 3.9316 5.39751 3.44318 6 3.44318C6.60249 3.44318 7.09091 3.9316 7.09091 4.53409C7.09091 5.13658 6.60249 5.625 6 5.625C5.69875 5.625 5.45455 5.86921 5.45455 6.17045V7.26136H6.54545V6.64717C7.48649 6.40497 8.18182 5.55073 8.18182 4.53409C8.18182 3.32911 7.20498 2.35227 6 2.35227ZM6.68182 9.03409C6.68182 9.41065 6.37655 9.71591 6 9.71591C5.62345 9.71591 5.31818 9.41065 5.31818 9.03409C5.31818 8.65754 5.62345 8.35227 6 8.35227C6.37655 8.35227 6.68182 8.65754 6.68182 9.03409Z"
        fill="#BAC0CA"
      />
    </svg>
    <svg
      v-if="name === 'ai-analysis'"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_42612_34897)">
        <path
          d="M6.68164 4.71484C6.68164 4.71484 6.38654 8.23943 4.79102 9.79883C3.216 11.3375 -0.25 11.7051 -0.25 11.7051C-0.25 11.7051 3.21588 12.0719 4.79102 13.6113C6.38654 15.1698 6.68164 18.6963 6.68164 18.6963C6.68164 18.6963 6.9767 15.1698 8.57129 13.6113C10.1473 12.0718 13.6123 11.7051 13.6123 11.7051C13.6013 11.7039 10.1447 11.3351 8.57129 9.79883C6.97945 8.24193 6.68261 4.72641 6.68164 4.71484ZM16.5879 12.8359C16.5879 12.8359 16.4635 14.2984 15.7979 14.9443C15.1428 15.5794 13.7014 15.7328 13.6865 15.7344C13.7006 15.7358 15.1353 15.88 15.7979 16.5244C16.4605 17.1692 16.5867 18.6195 16.5879 18.6328C16.5893 18.617 16.7222 17.1577 17.377 16.5244C18.0352 15.8877 19.4834 15.7344 19.4834 15.7344C19.4801 15.734 18.0437 15.5896 17.377 14.9443C16.7108 14.2997 16.5884 12.8418 16.5879 12.8359ZM15.1465 1.30078C15.1463 1.30334 14.9509 3.6226 13.8926 4.64844C12.8451 5.66335 10.543 5.9043 10.543 5.9043C10.543 5.9043 12.8298 6.13375 13.8926 7.16016C14.9553 8.18657 15.1465 10.5078 15.1465 10.5078C15.1465 10.5078 15.353 8.17509 16.4023 7.16016C17.4511 6.14589 19.7471 5.9046 19.75 5.9043C19.75 5.9043 17.467 5.67484 16.4023 4.64844C15.3376 3.62203 15.1465 1.30078 15.1465 1.30078Z"
          fill="url(#paint0_linear_42612_34897)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_42612_34897"
          x1="4"
          y1="5"
          x2="13.7085"
          y2="14.7786"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.259615" stop-color="#57D9FF" />
          <stop offset="1" stop-color="#B694FF" />
        </linearGradient>
        <clipPath id="clip0_42612_34897">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="matrix(-1 0 0 1 20 0)"
          />
        </clipPath>
      </defs>
    </svg>
    <svg
      v-if="name === 'ai-analysis1'"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_42616_36166)">
        <path
          d="M6.68164 4.71484C6.68164 4.71484 6.38654 8.23943 4.79102 9.79883C3.216 11.3375 -0.25 11.7051 -0.25 11.7051C-0.25 11.7051 3.21588 12.0719 4.79102 13.6113C6.38654 15.1698 6.68164 18.6963 6.68164 18.6963C6.68164 18.6963 6.9767 15.1698 8.57129 13.6113C10.1473 12.0718 13.6123 11.7051 13.6123 11.7051C13.6013 11.7039 10.1447 11.3351 8.57129 9.79883C6.97945 8.24193 6.68261 4.72641 6.68164 4.71484ZM16.5879 12.8359C16.5879 12.8359 16.4635 14.2984 15.7979 14.9443C15.1428 15.5794 13.7014 15.7328 13.6865 15.7344C13.7006 15.7358 15.1353 15.88 15.7979 16.5244C16.4605 17.1692 16.5867 18.6195 16.5879 18.6328C16.5893 18.617 16.7222 17.1577 17.377 16.5244C18.0352 15.8877 19.4834 15.7344 19.4834 15.7344C19.4801 15.734 18.0437 15.5896 17.377 14.9443C16.7108 14.2997 16.5884 12.8418 16.5879 12.8359ZM15.1465 1.30078C15.1463 1.30334 14.9509 3.6226 13.8926 4.64844C12.8451 5.66335 10.543 5.9043 10.543 5.9043C10.543 5.9043 12.8298 6.13375 13.8926 7.16016C14.9553 8.18657 15.1465 10.5078 15.1465 10.5078C15.1465 10.5078 15.353 8.17509 16.4023 7.16016C17.4511 6.14589 19.7471 5.9046 19.75 5.9043C19.75 5.9043 17.467 5.67484 16.4023 4.64844C15.3376 3.62203 15.1465 1.30078 15.1465 1.30078Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_42616_36166">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="matrix(-1 0 0 1 20 0)"
          />
        </clipPath>
      </defs>
    </svg>

    <svg
      v-if="name === 'analysis-btn-icon'"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.28011 11.9909L5.96494 10.1595C5.53246 10.6288 4.97064 10.9553 4.35253 11.0967C3.73442 11.238 3.08863 11.1877 2.49914 10.9522C1.90965 10.7167 1.40374 10.3069 1.0472 9.77619C0.690667 9.24545 0.5 8.6183 0.5 7.97629C0.5 7.33428 0.690667 6.70713 1.0472 6.17639C1.40374 5.64565 1.90965 5.23588 2.49914 5.00038C3.08863 4.76488 3.73442 4.71454 4.35253 4.85591C4.97064 4.99727 5.53246 5.32381 5.96494 5.79304L9.28011 3.99366C9.21328 3.7326 9.18142 3.46361 9.18539 3.19394C9.18653 2.44955 9.44386 1.72887 9.91306 1.15604C10.3823 0.583213 11.0339 0.194106 11.7558 0.0557474C12.4778 -0.0826109 13.2247 0.0384429 13.868 0.398056C14.5113 0.757669 15.0106 1.33332 15.2801 2.02586C15.5495 2.71839 15.5721 3.48444 15.344 4.19205C15.1159 4.89965 14.6513 5.50451 14.0304 5.90242C13.4095 6.30033 12.671 6.46638 11.9422 6.37196C11.2135 6.27755 10.54 5.92859 10.0379 5.38518L6.72269 7.19256C6.78905 7.45371 6.82091 7.72264 6.81741 7.99228C6.81909 8.26234 6.78457 8.53137 6.7148 8.79201L10.03 10.6234C10.5309 10.0773 11.2044 9.72558 11.9341 9.6291C12.6638 9.53262 13.4038 9.69739 14.0263 10.095C14.6488 10.4925 15.1147 11.0979 15.3435 11.8065C15.5723 12.5151 15.5496 13.2824 15.2794 13.9759C15.0091 14.6693 14.5083 15.2454 13.8634 15.6045C13.2185 15.9636 12.4701 16.0832 11.7475 15.9426C11.0248 15.8021 10.3733 15.4102 9.90548 14.8347C9.43768 14.2592 9.18298 13.5362 9.18539 12.7906C9.18301 12.5205 9.21754 12.2514 9.288 11.9909H9.28011ZM3.6601 9.59173C4.07879 9.59173 4.48032 9.42322 4.77638 9.12326C5.07243 8.82331 5.23876 8.41648 5.23876 7.99228C5.23876 7.56808 5.07243 7.16126 4.77638 6.8613C4.48032 6.56135 4.07879 6.39284 3.6601 6.39284C3.24142 6.39284 2.83988 6.56135 2.54383 6.8613C2.24777 7.16126 2.08145 7.56808 2.08145 7.99228C2.08145 8.41648 2.24777 8.82331 2.54383 9.12326C2.83988 9.42322 3.24142 9.59173 3.6601 9.59173ZM12.3427 4.79339C12.7614 4.79339 13.1629 4.62487 13.459 4.32492C13.755 4.02496 13.9214 3.61814 13.9214 3.19394C13.9214 2.76974 13.755 2.36291 13.459 2.06296C13.1629 1.763 12.7614 1.59449 12.3427 1.59449C11.924 1.59449 11.5225 1.763 11.2264 2.06296C10.9304 2.36291 10.764 2.76974 10.764 3.19394C10.764 3.61814 10.9304 4.02496 11.2264 4.32492C11.5225 4.62487 11.924 4.79339 12.3427 4.79339ZM12.3427 14.3901C12.7614 14.3901 13.1629 14.2216 13.459 13.9216C13.755 13.6217 13.9214 13.2148 13.9214 12.7906C13.9214 12.3664 13.755 11.9596 13.459 11.6596C13.1629 11.3597 12.7614 11.1912 12.3427 11.1912C11.924 11.1912 11.5225 11.3597 11.2264 11.6596C10.9304 11.9596 10.764 12.3664 10.764 12.7906C10.764 13.2148 10.9304 13.6217 11.2264 13.9216C11.5225 14.2216 11.924 14.3901 12.3427 14.3901Z"
        fill="white"
      />
    </svg>
    <svg
      v-if="name === 'ai-icon'"
      width="58"
      height="58"
      viewBox="0 0 58 58"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="58"
        height="58"
        rx="16"
        fill="url(#paint0_linear_42612_36158)"
      />
      <g clip-path="url(#clip0_42612_36158)">
        <path
          d="M39.4358 37.8963C40.634 36.7335 40.857 34.1016 40.857 34.1016C40.857 34.1016 41.0767 36.7335 42.2783 37.8963C43.4798 39.059 46.0693 39.3189 46.0693 39.3189C46.0693 39.3189 43.4632 39.5954 42.2783 40.7414C41.0934 41.8875 40.857 44.5361 40.857 44.5361C40.857 44.5361 40.634 41.9075 39.4358 40.7414C38.2376 39.5754 35.6348 39.3189 35.6348 39.3189C35.6348 39.3189 38.2509 39.0457 39.4358 37.8963Z"
          fill="white"
          fill-opacity="0.7"
        />
        <path
          d="M36.0058 19.3728C37.9119 17.5253 38.2635 13.3477 38.2635 13.3477C38.2635 13.3477 38.6082 17.5253 40.5247 19.3728C42.4411 21.2203 46.5498 21.6339 46.5498 21.6339C46.5498 21.6339 42.4136 22.0682 40.5247 23.8951C38.6358 25.7219 38.2635 29.9202 38.2635 29.9202C38.2635 29.9202 37.9188 25.7426 36.0058 23.8951C34.0928 22.0476 29.9772 21.6339 29.9772 21.6339C29.9772 21.6339 34.1204 21.1996 36.0058 19.3728Z"
          fill="white"
          fill-opacity="0.89"
        />
        <path
          d="M19.6241 28.6399C22.496 25.833 23.0261 19.4883 23.0261 19.4883C23.0261 19.4883 23.5579 25.833 26.4282 28.6399C29.2649 31.4096 35.502 32.0712 35.502 32.0712C35.502 32.0712 29.2649 32.731 26.4282 35.5024C23.5579 38.3076 23.0261 44.654 23.0261 44.654C23.0261 44.654 22.496 38.3076 19.6241 35.5024C16.7891 32.731 10.5503 32.0712 10.5503 32.0712C10.5503 32.0712 16.7891 31.4096 19.6241 28.6399Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_42612_36158"
          x1="17.9455"
          y1="1.82434"
          x2="50.6171"
          y2="52.1074"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#57D9FF" />
          <stop offset="0.427885" stop-color="#489AF6" />
          <stop offset="1" stop-color="#8952FF" />
        </linearGradient>
        <clipPath id="clip0_42612_36158">
          <rect
            width="36"
            height="36"
            fill="white"
            transform="matrix(-1 0 0 1 47 11)"
          />
        </clipPath>
      </defs>
    </svg>
  </div>
</template>

<script>
export default {
  name: "homeIcons",
  props: {
    name: {
      type: String,
      required: true,
    },
  },
};
</script>
<style lang="less" scoped>
// .icon-hover {
//   color: #f2f4f6; // 默认颜色
//   transition: color 0.2s;
// }
// .icon-hover:hover {
//   color: rgba(162, 169, 182, 1);
// }
</style>
